var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGtm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M134.6 248.2L8.5 122.1c-11.3-11.3-11.3-29.6 0-40.8L120.3 -30.4c11.3-11.3 29.6-11.3 40.8 0L287.2 95.7c11.3 11.3 11.3 29.6 0 40.8L175.4 248.2c-11.3 11.3-29.6 11.3-40.8 0z",
    fill: "#8AB4F8",
    transform: "translate(-15,12) scale(0.92)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M141.6 247.5l-50.8-50.8 50.8-50.8 50.8 50.8-50.8 50.8z",
    fill: "#246FDB",
    transform: "translate(-15,-15)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M134.6 248.2L8.5 122.1c-11.3-11.3-11.3-29.6 0-40.8l113.1-113.1c-11.3 11.3-11.3 29.6 0 40.8l126.1 126.1-113 113.1z",
    fill: "#246FDB",
    opacity: 0.85,
    transform: "translate(-15,12) scale(0.92)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGtm);
export default __webpack_public_path__ + "static/media/gtm.d64ccd54ec3215b8a58fdafad55f44b8.svg";
export { ForwardRef as ReactComponent };